import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Brain, Sparkles, Zap, Bot, Settings } from 'lucide-react';
import './AISupportingBeliefs.css';

const AISupportingBeliefs: React.FC = () => {
  const navigate = useNavigate();

  const handleMassAIAction = () => {
    navigate('/MassAIPowerUserAction');
  };

  const handleMassProbabilisticAction = () => {
    navigate('/MassProbabilisticSupportingBeliefAssignment');
  };

  return (
    <div className="ai-supporting-beliefs-page">
      <div className="ai-header">
        <div className="header-top">
          <div className="header-title">
            <Brain size={32} />
            <h1>AI Supporting Beliefs</h1>
          </div>
          <div className="header-actions">
            <button className="btn-primary mass-ai-action-btn" onClick={handleMassAIAction}>
              <Settings size={16} />
              Mass AI Power User Action
            </button>
            <button
              className="btn-primary mass-probabilistic-btn"
              onClick={handleMassProbabilisticAction}
            >
              <Brain size={16} />
              Mass Probabilistic Supporting Belief Assignment
            </button>
            <div className="header-badge">
              <Sparkles size={16} />
              <span>AI Wizard</span>
            </div>
          </div>
        </div>
        <p className="header-description">
          Use artificial intelligence to analyze and suggest supporting beliefs for thoughts in the
          system.
        </p>
      </div>

      <div className="ai-content">
        <div className="wizard-cards">
          <div className="wizard-card">
            <div className="wizard-card-header">
              <Zap size={24} />
              <h3>Auto-Generate Support</h3>
            </div>
            <div className="wizard-card-content">
              <p>
                Automatically generate supporting beliefs for thoughts using AI analysis of existing
                belief patterns and logical connections.
              </p>
              <button className="btn-primary">
                <Bot size={16} />
                Start AI Analysis
              </button>
            </div>
          </div>

          <div className="wizard-card">
            <div className="wizard-card-header">
              <Brain size={24} />
              <h3>Belief Network Analysis</h3>
            </div>
            <div className="wizard-card-content">
              <p>
                Analyze the network of beliefs to identify gaps and suggest new supporting
                relationships between existing thoughts.
              </p>
              <button className="btn-secondary">
                <Sparkles size={16} />
                Analyze Network
              </button>
            </div>
          </div>

          <div className="wizard-card">
            <div className="wizard-card-header">
              <Sparkles size={24} />
              <h3>Smart Recommendations</h3>
            </div>
            <div className="wizard-card-content">
              <p>
                Get AI-powered recommendations for strengthening belief structures and improving
                logical consistency across the platform.
              </p>
              <button className="btn-secondary">
                <Brain size={16} />
                Get Recommendations
              </button>
            </div>
          </div>
        </div>

        <div className="coming-soon-notice">
          <div className="notice-content">
            <Bot size={48} />
            <h2>Coming Soon</h2>
            <p>
              AI Supporting Beliefs wizard is currently in development. This powerful tool will help
              administrators and users discover and create meaningful connections between thoughts
              and beliefs.
            </p>
            <div className="features-preview">
              <div className="feature-item">
                <Zap size={16} />
                <span>Automated belief generation</span>
              </div>
              <div className="feature-item">
                <Brain size={16} />
                <span>Intelligent pattern recognition</span>
              </div>
              <div className="feature-item">
                <Sparkles size={16} />
                <span>Smart relationship mapping</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AISupportingBeliefs;
